import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, Subject } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { AggregationRequest } from 'src/app/common-interfaces-classes/AggregationRequest';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { OpenaiService } from 'src/app/openai/openai.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-attrtion-tab',
    templateUrl: './attrtion-tab.component.html',
    styleUrls: ['./attrtion-tab.component.scss'],
    standalone: false
})
export class AttrtionTabComponent implements OnInit {

  constructor(private personSearchService: PersonSearchService, private location: Location, private companyinsightservive: CompanyInsightsService, private hashService: HashService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private talentInsightsService: TalentInsightsService, private openaiService: OpenaiService,
    private localStorageService: LocalStorageService) { }
  companyDetails: any;
  currentCompanyName: any;
  functionStartIndex: number = 0;
  functions: any = [];
  functionsData: any = [];
  totalFunctionResultCount: number = 0;
  displayedColumns: string[] = ['key', 'attrition', 'hirecount', 'job_doc_count'];
  @ViewChild('attritionTbSort') attritionTbSort: MatSort;
  top_next_employers_by_role: any;
  isViewMore: string = 'View More';
  recentAttritionAll: any[] = [];
  recentAttrition: any = [];
  recentAttritionStartIndex: number = 0;
  isViewMoreRecentAttrition: boolean = true;
  alternatecompanyNames: any[] = [];
  recentHiresDataAll: any[] = [];
  recentHiresData: any = [];
  attritionsubscription: Subscription;

  /** start index in function page */
  startFunction: number = 0;
  /**End index in function page */
  endFunction: number = 5;
  /**Number of items on each of function page */
  pageSizeFunction: number = 5;
  /**Current page number in function */
  currentPageFunction: number = 1;
  /**Total items in function page*/
  totalCountFunction = 0;
  aggregatescount: number = 50;

  /** start index in function page */
  startAttrtion: number = 0;
  /**Number of items on each of function page */
  pageSizeAttrtion: number = 6;
  /**Current page number in function */
  currentPageAttrtion: number = 1;
  /**Total items in function page*/
  totalCountAttrtion = 0;
  attrtionCount = 6;

  /**Data from Recent Attirion pending or not */
  recentAttiritonPending: boolean = true;

  /**Data from Recent hire is pedning or not */
  recentHiresPending: boolean = true;

  /**start index of recent hire for pagination */
  recentHireStartIndex: number = 0;
  /**Current page of recent hire */
  recentHireCurrentPage: number = 1;
  /**Page size of recent hire */
  recentHirePageSize: number = 6;
  recentHireAggCount = 6;
  /**Duration of recent hires in months */
  selectedMonth: any = '12';
  /**Total number of recent hires */
  totalRecentHiresCount: number = 0;
  attritionSortArr: any = [];

  /** Duration filter for recent hires */
  selectedMonthsRecentAttrition: string = '12';

  attritionemptystate: Boolean = false;
  functionsname: any
  totalresultcount: any;
  attritiondataAI: any;
  /** Subscription var */
  subscriptions: Array<Subscription> = [];

  insightsExportSubscription: Subscription = null;

  companyinsightsFilter: any = {};

  /**
 * Mapping of key and text value of headers
 * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
 */
  tableHeaderObj = {
    "Role": "Role",
    "Attrition": "Attrition (%)",
    "Hiring": "Hiring (%)",
    "JobDemand": "Job Posts"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  combinedAggregates: any;
  combinedIndustry: any;
  combinedSkills: any;
  combinedJobtitle: any;
  combinedLocation: any;


  hasJobDemand: boolean = false;
hasMedianSalary: boolean = false;
 sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  sliderPayload:any
hasJobListingAccess:any
  filterData: any;
  aiSuggestions: any;


  ngOnInit(): void {
    // this.attritionsubscription = this.personSearchService.companyDetail.subscribe((response) => {
    //   this.companyDetails = response;
    //   this.recentAttrition = [];
    //   this.recentHiresData = [];
    //   this.currentCompanyName = this.companyDetails.name;
    //   this.alternatecompanyNames = this.companyDetails.alternative_names && this.companyDetails.alternative_names.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];
    //   this.top_next_employers_by_role = this.companyDetails.top_next_employers_by_role;
    //   this.totalAttritionCount = this.top_next_employers_by_role && this.top_next_employers_by_role.all ? Object.values(this.top_next_employers_by_role.all).reduce((a: number, b: number) => a + b, 0) : 0;

    this.startFunction = 0;
    this.endFunction = 5;
    this.currentPageAttrtion = 1;

    this.startAttrtion = 0;
    this.currentPageFunction = 1;

    this.recentHireStartIndex = 0;
    this.recentHireCurrentPage = 1;

    this.setCompanyDetails();
    this.getJobtitleSkillSuggestions();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      this.filterData = _methodDetails;
        if (this.filterData?.filterType == 'skills' || this.filterData?.filterType == 'jobtitle' || this.filterData?.filterType == 'keyword' || this.filterData?.filterType == 'pastjobtitle' || this.filterData?.filterType == 'search' || this.filterData?.filterType == 'allfilters') {
        this.getJobtitleSkillSuggestions();
      } else if (this.filterData?.filterType == 'location' || this.filterData?.filterType == 'industry' || this.filterData?.filterType == 'company' || this.filterData?.filterType == 'seniority' || this.filterData?.filterType == 'function' || this.filterData?.filterType == 'functions' || this.filterData?.filterType == 'locationRange') {
        this.fetchPageData();
      } else {
        this.fetchPageData();
      }
    });
    this.subscriptions.push(filterMethodEvent);
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightservive.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
    this.hasJobListingAccess = this.localStorageService.getItem('hasjoblistingaccess')
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightservive.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.getFunction();
    this.getRecentAttrition();
    this.getRecentHires();
  }

  filterselected(event, type: string) {
    if (type == 'recentHire') {
      this.selectedMonth = event.target.value;
      this.recentHireStartIndex = 0;
      this.recentHireAggCount = 6;
      this.recentHireCurrentPage = 1;
      this.recentHiresData = [];
      this.getRecentHires();
    } else if (type == 'recentAttrition') {
      this.selectedMonthsRecentAttrition = event.target.value;
      this.setPageAttrtion(1);
    }
  }

  getRecentHires() {
    this.recentHiresPending = true;
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject: AggregationRequest = this.aggService.getRequestWithFilters();
    requestObject.companies = this.alternatecompanyNames;
    requestObject.durationinmonths = parseInt(this.selectedMonth);
    requestObject.resultsize = 50; // this.recentHireAggCount;
    requestObject.startindex = this.recentHireStartIndex;
    requestObject.companyids = [this.companyDetails.id];
    requestObject.recentcompanyhires = true;
    this.personSearchService.getPersonSearchRecommendCandidates(requestObject).subscribe((response) => {
      this.recentHiresDataAll = response.data.results;
      this.recentHiresData = (this.recentHiresDataAll || []).slice(0, 6);
      this.totalRecentHiresCount = response.data.totalresultscount || 0;
      this.recentHiresPending = false;
    });
  }

  getRecentAttrition() {
    this.recentAttiritonPending = true;
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject: AggregationRequest = this.aggService.getRequestWithFilters();
    // requestObject.companies = this.alternatecompanyNames;
    requestObject.resultsize = 50; // this.attrtionCount;
    requestObject.startindex = this.startAttrtion;
    // requestObject.companyids = [this.companyDetails.id];
    requestObject.lastjobcompanyids = [this.companyDetails.id];
    requestObject.recentcompanyattrition = true
    requestObject.durationinmonths = parseInt(this.selectedMonthsRecentAttrition);
    // this.personSearchService.getRecentAttritionData(requestObject).subscribe((response) => {
    //   this.recentAttritionAll = response.data;
    //   this.recentAttrition = (this.recentAttritionAll || []).slice(0, 6);
    //   this.totalCountAttrtion = response.totalresultscount || 0;
    //   this.recentAttiritonPending = false;
    // });
    this.personSearchService.getPersonSearchRecommendCandidates(requestObject).subscribe((response) => {
      this.recentAttritionAll = response.data.results;
      this.recentAttrition = (this.recentAttritionAll || []).slice(0, 6);
      this.totalCountAttrtion = response.data.totalresultscount || 0;
      this.recentAttiritonPending = false;
    });
  }

  getFunction() {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "function";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightservive.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalFunctionResultCount = response.data.totalresultscount;
      const tempData = response.data.aggregations.function;


      this.totalCountFunction = tempData.length;

      this.functionsData = tempData.map((element) => {
        const count: any = this.top_next_employers_by_role && this.top_next_employers_by_role[element.key] ? Object.values(this.top_next_employers_by_role[element.key]).reduce((a: number, b: number) => a + b, 0) : 0;
        return { ...element, key: this.cleanCompanyName(element.key), attritionPercentage: this.totalCountAttrtion ? ((count / this.totalCountAttrtion) * 100).toFixed(2) : 0 }
      });
      this.attritionSortArr = this.functionsData;
      this.functionsData = this.functionsData.slice(this.startFunction, this.endFunction);

      this.functionsname = _.pluck(this.attritionSortArr, 'key')
      this.functions = new MatTableDataSource(this.functionsData);
      this.functions.sort = this.attritionTbSort;

      this.manualSort();
      this.getattrition();
      this.getrecenthires();
      this.getJobsAggregates();

      this.attritionemptystate = true;
    });
  }

  manualSort() {
    this.reSortArr(this.attritionTbSort);
  }

  reSortArr(sort) {
    const tempData = this.attritionSortArr;

    if (!sort || !sort.active || sort.direction === '') {
      this.functionsData = tempData.slice(this.startFunction, this.endFunction);
      this.functions = new MatTableDataSource(this.functionsData);
      this.functions.sort = this.attritionTbSort;
      return;
    }

    this.attritionSortArr = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'hirecount': return this.compare(a.hirecount, b.hirecount, isAsc);
        case 'attrition': return this.compare(a.attrition, b.attrition, isAsc);
        default: return 0;
      }
    })
    this.functionsData = this.attritionSortArr.slice(this.startFunction, this.endFunction);
    this.functions = new MatTableDataSource(this.functionsData);
    this.functions.sort = this.attritionTbSort;
  }

  compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
  * Function set the start and end of aggreggate data according to page number in title container
  * @param index page number in pagination
  */
  setPageFunction(index: number) {
    this.startFunction = (index - 1) * this.pageSizeFunction;
    this.endFunction = this.startFunction + this.pageSizeFunction;
    this.currentPageFunction = index;
    this.manualSort();
  }

  /**
  * Funtion set the start and end of attrition data according to page number in title container
  * @param index page number in pagination
  */
  setPageAttrtion(index: number) {
    this.startAttrtion = (index - 1) * this.pageSizeAttrtion;
    this.currentPageAttrtion = index;
    this.getRecentAttrition();
  }

  /**
   * Function set the start and end of recent hire data according to page number
   * @param index page number in pagination
   */
  setPageRecentHire(index: number) {
    this.recentHireStartIndex = (index - 1) * this.recentHirePageSize;
    this.recentHireCurrentPage = index;
    this.getRecentHires();
  }

  getEmployeePercentage(value) {
    return ((value / this.totalFunctionResultCount) * 100).toFixed(2);
  }

  private cleanCompanyName(companyName: string): string {
    return companyName.replace(/_/g, ' ');
  }

  /**
   * destroy subscriptions of filters
   */
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getattrition() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "pastfunction";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightservive.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations.pastfunction;
      this.totalresultcount = response.data.totalresultscount
      this.attritionSortArr.map(res => {
        const pastfunction = tempData.filter(x => x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
        res.attrition = pastfunction && pastfunction.doc_count ? this.getattritionpercentage(pastfunction.doc_count) : '0';
        return res;
      })
      this.getattritionai(this.attritionSortArr);
    })
  }

  getattritionpercentage(value) {
    return ((value / this.totalFunctionResultCount) * 100).toFixed(2);
  }

  getrecenthires() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightservive.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations.current_function;
      this.attritionSortArr.map(res => {
        const hires = tempData.filter(x => x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
        res.hirecount = hires && hires.doc_count ? this.getEmployeePercentage(hires.doc_count) : '0';
        return res;
      })
      this.getattritionai(this.attritionSortArr);
    })
  }

  getattritionai(data) {
    let attritiondata: any;
    attritiondata = data.map(x => {
      let res: any = {};
      res['Role'] = x.key;
      res['Attrition (%)'] = x.attrition + '%';
      res['Hiring (%)'] = x.hirecount + '%';
      res['Job Posts'] = x.job_doc_count || 0;
      return res;
    })

    this.attritiondataAI = {
      attrition: attritiondata
    }
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if (requestData?.data?.currentTab !== 'attritionandhiring') return;

    this.tableHeaderName = [this.tableHeaderObj['Role'], this.tableHeaderObj['Attrition'], this.tableHeaderObj['Hiring'], this.tableHeaderObj['JobDemand']];
    const attritionDataForExport = this.attritionSortArr.map(attrition => {
      return {
        ...attrition,
        job_doc_count: attrition.job_doc_count || '—',
      };
    });
    const payloadForInsightsExport: ExportPayload = {
      tab: 'attritionandhiring',
      companydetails: this.companyDetails,
      totalresultcount: this.totalresultcount,
      attrition: attritionDataForExport,
      recentAttrition: this.recentAttritionAll,
      recentHires: this.recentHiresDataAll,
      totalRecentHiresCount: this.totalRecentHiresCount,
      totalAttritionCount: this.totalCountAttrtion,
      tableHeader: this.tableHeaderName,
      selectedDurationRecentHire: this.selectedMonth,
      selectedDurationRecentAttrition: this.selectedMonthsRecentAttrition
    }
    this.companyinsightservive.sendInsightsExportData(payloadForInsightsExport);
  }

  getCombinedAggregates() {
    this.hasJobDemand = true;
    this.attritionSortArr = this.attritionSortArr.map(location => {
      location.median_salary = "";
      location.confidence_score = "";
      location.job_doc_count = '';
      return location;
    });

    const request = this.aggService.getRequestWithFilters();
    request.aggregatetype = "jobs_base_aggregates";
    request.aggregatescount = 50;
    request.companyids = [this.companyDetails.id];
    this.personSearchService.getTotalAggs(request).subscribe(response => {
      //   this.locationAPiCalled = true;
      const tempData = response?.data?.aggregations;
      this.combinedAggregates = tempData;
      this.combinedIndustry = this.combinedAggregates['current_industry'];
      this.combinedSkills = this.combinedAggregates['skills'];
      this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
      this.combinedLocation = this.combinedAggregates['location'];
      this.getJobsAggregates();
    });
  }

  getJobsAggregates() {
    this.hasJobDemand = true;
    this.aiSuggestions = this.localStorageService.getItem('companyaiSuggestions')
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'function-job_demand',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
      companyids: [this.companyDetails.id],
      excluded_functions: aggReq?.exclude_functions || [],
      excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],

    }
              this.sliderPayload = payload

    this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
      const tempData = response?.data?.aggregations['function-job_demand'];
      this.hasJobDemand = false;
      this.attritionSortArr.map(location => {
        const medianSalaryData = tempData.find(item => item.key.toLowerCase().trim() === location.key.toLowerCase().trim());
        if (medianSalaryData) {
          location.job_doc_count = medianSalaryData?.job_demand?.doc_count || '';
        } else {
          location.job_doc_count = '';
        }
        return location;
      });
      this.getattritionai(this.attritionSortArr);
    })
  }
  /**
   * Retrun true if data is still pending
   */
  getDataPendingStatus() {
    return this.hasMedianSalary || this.hasJobDemand;
  }
   openJoblistSlider(value:any){
     Object.assign(this.sliderPayload, {mandatory_functions:[value]})
      this.sendDataToSliderSubject.next(this.sliderPayload);

      this.toOpenSliderFromTabSubject.next({isOpen:true})
    }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    const additionalFilters = {};
    switch (type) {
      case 'recentGrowth': {
        additionalFilters['recentGrowth'] = [`Recent Hires - last ${this.selectedMonth} months`],
          additionalFilters['recentcompanyhires'] = true
        additionalFilters['durationinmonths'] = this.selectedMonth
        break;
      }
      case 'recentAttrtion': {
        additionalFilters['recentAttrtion'] = [`Recent Attrition - last ${this.selectedMonthsRecentAttrition} months`],
          additionalFilters['lastjobcompanyids'] = [this.companyDetails.id],
          additionalFilters['durationinmonths'] = this.selectedMonthsRecentAttrition,
          additionalFilters['recentcompanyattrition'] = true;
        break;
      }
    }
    this.companyinsightsFilter['additionalFilters'] = additionalFilters;
    this.companyinsightsFilter['name'] = this?.companyDetails?.name;
    this.companyinsightsFilter['alternative_names'] = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
    this.companyinsightsFilter['alternative_company_id'] = [this.companyDetails.id];

    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, this.companyinsightsFilter);
    const requestObject = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=company-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}&keyword=${requestObject.booleanquery != '*' ? encodeURIComponent(requestObject.booleanquery) : ''}`;
    window.open(url, "_blank");
  }

  getJobtitleSkillSuggestions() {
    const aggReq = this.aggService.getRequestWithFilters();
    if ((aggReq?.preferredskills?.length > 0 || aggReq?.jobtitles?.length > 0) || (aggReq?.booleanquery != '*') || aggReq?.pastjobtitles?.length > 0) {
      const payload = {
        skills: aggReq.preferredskills,
        jobtitles: aggReq?.jobtitles,
        boolean: aggReq.booleanquery == "*" ? null : aggReq.booleanquery
      }

      this.openaiService.getJobTitleAndSkillSuggestions(payload).subscribe(async (res: any) => {
        const responseData = res.data;
        const titles = [...(responseData.suggestedjobtitles || [])];
        const skills = [...(responseData.suggestedskills || [])];
        const filterSuggestions = {
          jobtitles: titles,
          skills: skills
        }
        this.localStorageService.setItem('companyaiSuggestions', filterSuggestions);
        this.fetchPageData();


      })
    } else {
      this.localStorageService.setItem('companyaiSuggestions', null);
      this.fetchPageData();
    }
  }

}
